'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

const getRemainingTimeInMsFromDate = (date) => {
    if (!(date instanceof Date))
        return 0;
    const endTime = date.getTime();
    const currentTime = Date.now();
    const diff = endTime - currentTime;
    return Math.max(0, diff);
};
const getRemainingTimeFromMs = (ms) => {
    const daysLeft = Math.floor(ms / 86400000);
    const hoursLeft = Math.floor((ms % 86400000) / 3600000);
    const minutesLeft = Math.floor((ms % 3600000) / 60000);
    const secondsLeft = Math.floor((ms % 60000) / 1000);
    return {
        daysLeft: Math.max(0, daysLeft),
        hoursLeft: Math.max(0, hoursLeft),
        minutesLeft: Math.max(0, minutesLeft),
        secondsLeft: Math.max(0, secondsLeft),
    };
};

exports.getRemainingTimeFromMs = getRemainingTimeFromMs;
exports.getRemainingTimeInMsFromDate = getRemainingTimeInMsFromDate;
//# sourceMappingURL=get-remaining-time.js.map
